import { render, staticRenderFns } from "./BaseDialogButton.vue?vue&type=template&id=16ba9a16&scoped=true&"
import script from "./BaseDialogButton.vue?vue&type=script&lang=js&"
export * from "./BaseDialogButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseDialogButton.vue?vue&type=style&index=0&id=16ba9a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba9a16",
  null
  
)

export default component.exports